import { Tabs } from '@volue/wave-react';
import React from 'react';

import { useActions, useAppState } from '@/overmind';

import type {
  AvailableCalculationScenarios,
  CompletedCalculationTactic
} from '../../overmind/calculation';
import { LoadFlowScenarioSelector } from './LoadFlowScenarioSelector';

export function SelectLoadFlowButton() {
  const browseTacticResults = useActions().calculation.browseTacticResults;

  const tacticResultBrowsingFilter =
    useAppState().calculation.tacticResultBrowsingFilter;

  const availableCalculationScenarios =
    useAppState().calculation.availableCalculationScenarios;

  const scenarios = GetScenarios();

  if (isMultipleScenario(availableCalculationScenarios, scenarios)) {
    return (
      <li
        className={
          tacticResultBrowsingFilter.type === 'SELECTED_LOAD_FLOW'
            ? 'is-active'
            : ''
        }
      >
        <LoadFlowScenarioSelector />
      </li>
    );
  }

  return (
    <Tabs.Trigger
      onClick={() =>
        browseTacticResults({
          type: 'SELECTED_LOAD_FLOW',
          scenarioIds: scenarios.map(scenario => scenario.scenarioId)
        })
      }
      value="SELECTED_LOAD_FLOW"
    >
      {'Load Flow'}
    </Tabs.Trigger>
  );
}

function GetScenarios() {
  const calculationResult =
    useAppState().calculation.calculationTactic.matches('LOADED')?.value;

  const completedCalculationTactic =
    calculationResult as CompletedCalculationTactic;

  const scenarios =
    completedCalculationTactic.calculationSetResult.calculationScenarios.loadFlow.map(
      scenario => ({
        scenarioName: scenario.scenarioName,
        scenarioId: scenario.scenarioId
      })
    );
  return scenarios;
}

function isMultipleScenario(
  availableCalculationScenarios: AvailableCalculationScenarios,
  scenarios: any
) {
  return (
    ((availableCalculationScenarios.type === 'SOME_AVAILABLE' &&
      availableCalculationScenarios.scenarios.has('LOAD_FLOW')) ||
      availableCalculationScenarios.type === 'ALL_AVAILABLE') &&
    scenarios.length > 1
  );
}
